
import { db } from './firebase';
import { collection, addDoc, Timestamp } from 'firebase/firestore';

export type AuditCategory = 'Clinical' | 'Operational' | 'Security' | 'Drug' | 'Governance' | 'Workforce';

export interface AuditEvent {
    schemaVersion: 1;
    immutable: true;
    source: 'webapp';
    tenantId?: string | null;
    actorUid: string;
    actorName: string;
    action: string;
    category: AuditCategory;
    details: string;
    targetType?: string;
    targetId?: string;
    metadata?: Record<string, string | number | boolean | null>;
    severity?: 'Info' | 'Warning' | 'Critical';
    occurredAt: string;
}

export interface WriteAuditEventInput {
    tenantId?: string | null;
    actorUid: string;
    actorName: string;
    action: string;
    category: AuditCategory;
    details: string;
    targetType?: string;
    targetId?: string;
    metadata?: Record<string, string | number | boolean | null>;
    severity?: 'Info' | 'Warning' | 'Critical';
}

export const writeAuditEvent = async (input: WriteAuditEventInput) => {
    const entry: AuditEvent = {
        schemaVersion: 1,
        immutable: true,
        source: 'webapp',
        tenantId: input.tenantId ?? null,
        actorUid: input.actorUid,
        actorName: input.actorName,
        action: input.action,
        category: input.category,
        details: input.details,
        targetType: input.targetType,
        targetId: input.targetId,
        metadata: input.metadata,
        severity: input.severity || 'Info',
        occurredAt: new Date().toISOString(),
    };

    await addDoc(collection(db, 'audit_logs'), {
        ...entry,
        serverTimestamp: Timestamp.now(),
    });
};

export const logAuditAction = async (
    userId: string, 
    userName: string, 
    action: string, 
    details: string, 
    category: AuditCategory,
    options?: {
        tenantId?: string | null;
        targetType?: string;
        targetId?: string;
        metadata?: Record<string, string | number | boolean | null>;
        severity?: 'Info' | 'Warning' | 'Critical';
    }
) => {
    try {
        await writeAuditEvent({
            tenantId: options?.tenantId,
            actorUid: userId,
            actorName: userName,
            action,
            category,
            details,
            targetType: options?.targetType,
            targetId: options?.targetId,
            metadata: options?.metadata,
            severity: options?.severity,
        });
    } catch (e) {
        console.error("Failed to log audit entry", e);
        // We log locally if remote fails to ensure at least console visibility
        console.warn("AUDIT FAILURE BACKUP:", action, details);
    }
};
